module.exports = __webpack_public_path__ + "media/message.2e80b9b5.wav";